/**
 * Run an async function with retries for transient failures (network, 5xx, timeout).
 */
export async function fetchWithRetry(fn, options = {}) {
  const {
    maxAttempts = 4,
    baseDelayMs = 800,
    maxDelayMs = 10000,
    backoffFactor = 2
  } = options;

  let lastErr;
  for (let attempt = 0; attempt < maxAttempts; attempt += 1) {
    try {
      return await fn();
    } catch (err) {
      lastErr = err;
      const status = err?.response?.status;
      const code = err?.code;
      const msg = String(err?.message || '');
      const isTimeout = code === 'ECONNABORTED' || msg.toLowerCase().includes('timeout');
      const isNetwork = !err?.response || code === 'ERR_NETWORK' || msg.includes('Network Error');
      const isServer = status >= 500 && status < 600;
      const isRateLimit = status === 429;
      const shouldRetry =
        isTimeout || isNetwork || isServer || isRateLimit || status === 408;

      if (!shouldRetry || attempt === maxAttempts - 1) {
        throw err;
      }

      const delay = Math.min(
        maxDelayMs,
        baseDelayMs * Math.pow(backoffFactor, attempt)
      );
      await new Promise((r) => setTimeout(r, delay));
    }
  }
  throw lastErr;
}
